// GENERATED by scripts/build-icons.mjs from icons/panel-left-open.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const PanelLeftOpen = createIcon('panel-left-open', [
  ['rect', { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
  ['path', { d: "M9 3v18" }],
  ['path', { d: "m14 9 3 3-3 3" }],
])
